import React from 'react';

const Check = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 26 35" {...props}>
    <path
      fill="currentColor"
      d="M3.8 34.2h18.7c2 0 3.5-1.7 3.5-3.7V17.1c0-2-1.6-3.7-3.5-3.7V8.5c0-4.7-3.7-8.5-8.2-8.5H12a8.4 8.4 0 00-8.2 8.5v5C2 13.4.3 15 .3 17v13.4c0 2 1.6 3.7 3.5 3.7zM6.2 8.5a6 6 0 015.8-6h2.3a6 6 0 015.9 6v5h-14v-5zm-3.5 8.6c0-.7.5-1.2 1.1-1.2h18.7c.6 0 1.2.5 1.2 1.2v13.4c0 .7-.6 1.2-1.2 1.2H3.8c-.6 0-1.1-.5-1.1-1.2V17.1z"
    />
    <path
      fill="currentColor"
      d="M10.8 22c0-1.4 1-2.5 2.4-2.5 1.3 0 2.3 1.1 2.3 2.5 0 .9-.5 1.6-1.2 2V27c0 .6-.5 1.2-1.1 1.2-.7 0-1.2-.6-1.2-1.2V24a2.5 2.5 0 01-1.2-2.1z"
    />
  </svg>
);

export default Check;
